import { apiClient } from "@/api/api-client";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type { CaseCategory } from "../../types/case-category";

const caseCategoryService = {
	...createBaseService<CaseCategory>("/case-categories"),
	listByBranch: async (params = {}) => {
		const response = await apiClient.get<{ data: CaseCategory[]; meta: Pagination }>("/case-categories", { params });

		return response.data;
	},
};

export default caseCategoryService;
